export const STAGES = [
  { id: 'check-in', name: 'Check-in', slaMinutes: 15, capacity: 5 },
  { id: 'prep', name: 'Prep', slaMinutes: 20, capacity: 4 },
  { id: 'fitment', name: 'Fitment', slaMinutes: 45, capacity: 6 },
  { id: 'quality-check', name: 'Quality Check', slaMinutes: 15, capacity: 3 },
  { id: 'curing', name: 'Curing', slaMinutes: 30, capacity: 8 },
  { id: 'final-inspection', name: 'Final Inspection', slaMinutes: 15, capacity: 4 },
  { id: 'collection', name: 'Collection', slaMinutes: 60, capacity: 10 },
];

export const SLA_STATUS = {
  ON_TRACK: 'ON_TRACK',
  WARNING: 'WARNING',
  BREACHED: 'BREACHED',
};

export const TECHNICIANS = [
  'J.Mokoena', 'A.Pretorius', 'S.Naidoo', 'K.Dube',
  'R.vdBerg', 'N.Khumalo', 'L.Patel', 'M.Botha',
  'T.Sithole', 'C.Visser', 'P.Oosthuizen', 'D.Ngcobo',
];

export const INSURERS = ['Santam', 'OUTsurance', 'Hollard', 'Retail'];

// SKU scheme: GL-{TYPE}-{MODEL3}-{YEAR}
// TYPE: WSC (windscreen), SDL (side-left), SDR (side-right), RER (rear)
export const SKU_TYPES = ['WSC', 'SDL', 'SDR', 'RER'];

export const SAFETY_DAYS_SEED = 84;
export const CALLBACKS_SEED = 2;
export const REVENUE_TODAY_SEED = 142000;
export const THROUGHPUT_ANCHOR = 6.0;
export const REVENUE_PER_HOUR_ANCHOR = 18500;
export const WIP_AGE_P90_ANCHOR = 18;
export const SKU_STOCK_LOW_SEED = 3;
export const TECHNICIANS_ON_SHIFT_ANCHOR = 11;
export const INSURANCE_SPLIT_ANCHOR = 68; // % insurance (rest retail)